import { defineMessages } from '@jutro/locale';

export default defineMessages({
    zipcode: {
        id: 'ml.gateway.views.mlSearchResults.Zipcode',
        defaultMessage: 'Zipcode'
    },
    state: {
        id: 'ml.gateway.views.mlSearchResults.State',
        defaultMessage: 'State'
    },
    select: {
        id: 'ml.gateway.views.mlSearchResults.Select',
        defaultMessage: 'Select'
    },
    searching: {
        id: 'gateway.views.mlSearchResults.Searching',
        defaultMessage: 'Searching...'
    },
    DOB: {
        id: 'gateway.views.mlSearchResults.DOB',
        defaultMessage: 'DOB: '
    },
    accountHolder: {
        id: 'gateway.views.mlSearchResults.ACCOUNT HOLDER',
        defaultMessage: 'ACCOUNT HOLDER'
    },
    address: {
        id: 'gateway.views.mlSearchResults.ADDRESS',
        defaultMessage: 'ADDRESS'
    },
    phone: {
        id: 'gateway.views.mlSearchResults.PHONE',
        defaultMessage: 'PHONE'
    },
    lineOfBusiness: {
        id: 'gateway.views.mlSearchResults.LINE OF BUSINESS',
        defaultMessage: 'LINE OF BUSINESS'
    },
    bundled: {
        id: 'gateway.views.mlSearchResults.BUNDLED',
        defaultMessage: 'BUNDLED'
    },
    policies: {
        id: 'gateway.views.mlSearchResults.POLICIES',
        defaultMessage: 'POLICIES'
    },
    compRater: {
        id: 'gateway.views.mlSearchResults.COMP RATER',
        defaultMessage: 'COMP RATER'
    },
    timeStamp:{
        id: 'gateway.views.mlSearchResults.TIME STAMP',
        defaultMessage: 'TIME STAMP'
    },
    bridge: {
        id: 'gateway.views.mlSearchResults.BRIDGE',
        defaultMessage: 'BRIDGE'
    },
    quoteBridged: {
        id: 'gateway.views.mlSearchResults.Quote Bridged',
        defaultMessage: 'Quote Bridged'
    },
    goto: {
        id: 'gateway.views.mlSearchResults.Go to',
        defaultMessage: 'Go to'
    },
    commonSearch: {
        id: 'gateway.views.mlSearchResults.Common Search',
        defaultMessage: 'Common Search'
    },
    weHaveFoundxARSPoliciesForx: {
        id: 'gateway.views.mlSearchResults.We have found x ARS policies for x',
        defaultMessage: 'We have found {countSpan} {strongARS} policies for {strongName}'
    },
    weHaveFoundOneARSPolicyFor: {
        id: 'gateway.views.mlSearchResults.We have found 1 ARS policy for',
        defaultMessage: 'We have found {countSpan} ARS policy for {strongName}'
    },
    weHaveFoundOneCompraterQuote: {
        id: 'gateway.views.mlSearchResults.We have found 1 Comprater quote',
        defaultMessage: 'We have found {countSpan} Comprater quote for {strongName}'
    },
    ARS: {
        id: 'gateway.views.mlSearchResults.ARS',
        defaultMessage: 'ARS'
    },
    viewARSPolicies: {
        id: 'gateway.views.mlSearchResults.VIEW ARS POLICIES',
        defaultMessage: 'VIEW ARS POLICIES'
    },
    weAreUnableToRetrieveARSPolicy: {
        id: 'gateway.views.mlSearchResults.We are unable to retrieve ARS policy records at this time. Please try again later',
        defaultMessage: 'We are unable to retrieve {strongARS} policy records at this time. Please try again later.'
    },
    searchTips: {
        id: 'gateway.views.mlSearchResults.Search Tips',
        defaultMessage: 'Search Tips:'
    },
    whenSearchingByActName: {
        id: 'gateway.views.mlSearchResults.When searching by account name',
        defaultMessage: 'When searching by account name, enter complete last name and at least two characters of first name (ex: Johnson, Bru)'
    },
    whenSearchingByFullTextName: {
        id: 'gateway.views.mlSearchResults.When full text searching by account name',
        defaultMessage: 'When searching by name, enter as much of the first and last name of the customer'
    },
    fullTextSearchingByQuote: {
        id: "gateway.views.mlSearchResults.full text searching by quote",
        defaultMessage: "When searching by quote, provide the complete quote number (ex: 0123456789, HVQ0123456789)"
    },
    fullTextSearchingByPolicy: {
        id: "gateway.views.mlSearchResults.full text searching by policy",
        defaultMessage: "When searching by policy number, include policy type prefix: A-Auto, H-Home, U-Umbrella (ex: A1234567890)"
    },
    fullTextSearchingByPhone: {
        id: "gateway.views.mlSearchResults.full text searching by phone",
        defaultMessage: "When searching by phone number, enter the exact number in phone format (ex: 555-555-0100, (555) 555-0100)"
    },
    fullTextSearchingByAddress: {
        id: "gateway.views.mlSearchResults.full text searching by address",
        defaultMessage: "When searching by address, provide the full street address"
    },
    checkYourSpelling: {
        id: 'gateway.views.mlSearchResults.Check your spelling',
        defaultMessage: 'Check your spelling'
    },
    whenSearchingByPolicyNumber: {
        id: 'gateway.views.mlSearchResults.When searching by policy number',
        defaultMessage: 'When searching by policy number, include the policy type prefix: A-Auto, H-Home, U-Umbrella (ex: A123456789)'
    },
    whenSearchingBySubmissionNumber: {
        id: 'gateway.views.mlSearchResults.When searching by submission number',
        defaultMessage: 'When searching by submission number, use the quote number'
    },
    whenDoExpandedQuoteSearch: {
        id: 'gateway.views.mlSearchResultsWhen doing the expanded quote search',
        defaultMessage: 'When doing the expanded quote search, please verify you entered the correct submission number and zip code'
    },
    contactUsForAssistance: {
        id: 'gateway.views.mlSearchResults.contact us for assistance',
        defaultMessage: 'If you are unable to locate your customer, contact us for assistance.'
    },
    HVQSearchTip1: {
        id: 'gateway.views.mlSearchResults.HVQ Search Tip #1',
        defaultMessage: 'When searching by name, enter complete last name and at least two characters of first name (ex: Johnson, Bru)'
    },
    HVQSearchTip2: {
        id: 'gateway.views.mlSearchResults.HVQ Search Tip #2',
        defaultMessage: 'Check your spelling'
    },
    HVQSearchTip3: {
        id: 'gateway.views.mlSearchResults.HVQ Search Tip #3',
        defaultMessage: 'When searching by Quote ID, use the comp rater quote number'
    },
    searchError: {
        id: 'gateway.views.mlSearchResults.Search Error',
        defaultMessage: 'Could not complete search at this time.'
    },
    quoteIsNotComplete: {
        id: 'gateway.views.mlSearchResults.Quote is not complete',
        defaultMessage: 'Quote is not complete'
    },
    contactBookConsolidationManager: {
        id: 'gateway.views.mlSearchResults.Please contact your Book Consolidation manager',
        defaultMessage: 'Quote has not been completed. Please contact your Book Consolidation manager.'
    },
    contactForAssistance: {
        id: 'gateway.views.mlSearchResults.Contact us at 1-800-255-0332 for assistance',
        defaultMessage: 'Quote has not been completed. Contact us at 1-800-255-0332 for assistance.'
    },
    quoteMustCompleteInPC: {
        id: 'gateway.views.mlSearchResults.The quote must be completed in PolicyCenter',
        defaultMessage: 'Quote has not been completed. The quote must be completed in PolicyCenter.'
    },
    noAccountsFoundFiltered: {
        id: 'gateway.views.mlSearchResults.No accounts found filtered by xState xZipcode',
        defaultMessage: 'No accounts found filtered by {state} {zipCode}'
    },
    submissionNumber: {
        id: 'gateway.views.mlSearchResults.Submission #',
        defaultMessage: 'Submission #'
    },
    sorryForSubmissionQuery: {
        id: 'gateway.views.mlSearchResults.there are xCount matches for Submission #xQuery in Zip code xZipCode',
        defaultMessage: 'Sorry, there are {countSpan} matches for {boldSubmission} in {boldZipcode}'
    },
    sorryForxQueryInxStatexZipCode: {
        id: 'gateway.views.mlSearchResults.there are xCount matches for xQuery in xState xZipCode',
        defaultMessage: 'Sorry, there are {countSpan} matches for {boldQuery} in {boldStateZipcode}'
    },
    sorryForxQuery: {
        id: 'gateway.views.mlSearchResults.there are xCount matches for xQuery',
        defaultMessage: 'Sorry, there are {countSpan} matches for {boldQuery}'
    },
    xCountMatchesForSubmissionxQuery: {
        id: 'gateway.views.mlSearchResults.We found xCount matches for Submission #xQuery in Zip code xZipCod',
        defaultMessage: 'We found {countSpan} matches for {boldSubmission} in {boldZipcode}'
    },
    xCountMatchesForxQueryInxStatexZipCode: {
        id: 'gateway.views.mlSearchResults.We found xCount matches for xQuery in xState xZipCode',
        defaultMessage: 'We found {countSpan} matches for {query} in {boldStateZipcode}'
    },
    xCountMatchesForxQuery: {
        id: 'gateway.views.mlSearchResults.We found xCount matches for xQuery',
        defaultMessage: 'We found {countSpan} matches for {boldQuery}'
    },
    errorBridgingOperation: {
        id: 'gateway.views.mlSearchResults.Error in bridging operation',
        defaultMessage: 'Error in bridging operation'
    },
    errorBridgingxID: {
        id: 'gateway.views.mlSearchResults.Unable to bridge xID',
        defaultMessage: 'Unable to bridge {quoteID}. Please try again.'
    },
    errorInTakeOverOperation: {
        id: 'gateway.views.mlSearchResults.Error in take over operation',
        defaultMessage: 'Error in take over operation'
    },
    unableToTakeOverxID: {
        id: 'gateway.views.mlSearchResults.Unable to take over xID',
        defaultMessage: 'Unable to take over {quoteID}. Please try again.'
    },
    bridgingInProgress: {
        id: 'gateway.views.mlSearchResults.Bridging in progress',
        defaultMessage: 'Bridging in progress...'
    },
    loading: {
        id: 'gateway.views.mlSearchResults.Loading',
        defaultMessage: 'Loading...'
    },
    backToSearchResult: {
        id: 'gateway.views.mlSearchResults.Back to search result',
        defaultMessage: 'Back to search results'
    },
    foundxCountMatchesForxARSQuery: {
        id: 'gateway.views.mlSearchResults.We found xCount matches for ARS xQuery',
        defaultMessage: 'We found {countSpan} matches for {boldQuery}'
    },
    close: {
        id: 'gateway.views.mlSearchResults.CLOSE',
        defaultMessage: 'CLOSE'
    },
    altQuoteInd: {
        id: 'gateway.views.mlSearchResults.Alternate Quote',
        defaultMessage: ' - Alternate Quote'
    }
});
